import React from 'react';

import { noop } from '@utils';
import CustomDateRangePicker from '../DateRangePicker';
import { CustomDateRangePickerValue } from '../DateRangePicker/CustomDateRangePicker';
import InputLabelWrapper from '../InputLabelWrapper';

interface InputDateRangeProps {
	id?: string;
	label: string;
	isSortable: boolean;
	sortDirection: 'ascending' | 'descending' | 'none';
	onLabelClick?: (event: React.MouseEvent) => void;
	onChange: (value: CustomDateRangePickerValue) => void;
	value?: CustomDateRangePickerValue;
	labelDirection?: 'row' | 'col';
}

const InputDateRange: React.FC<InputDateRangeProps> = ({
	id,
	label,
	isSortable,
	sortDirection,
	onLabelClick = noop,
	value = {
		startDate: undefined,
		endDate: undefined,
	},
	labelDirection = 'row',
	onChange,
}: InputDateRangeProps) => {
	const { startDate, endDate } = value as CustomDateRangePickerValue;
	const onClickHandler = (event: React.MouseEvent) => {
		event.preventDefault();
		onLabelClick?.(event);
	};

	return (
		<InputLabelWrapper
			label={label}
			isSortable={isSortable}
			sortDirection={sortDirection}
			onLabelClick={onClickHandler}
			direction={labelDirection}
		>
			<div className="absolute">
				<CustomDateRangePicker id={id} value={{ startDate, endDate }} onChange={onChange} />
			</div>
		</InputLabelWrapper>
	);
};

export default InputDateRange;
